import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectPermissions, selectEntitledFeatures } from "@/auth/authSlice";

export default function useEntitlements() {
    const permissions = useSelector(selectPermissions);
    const entitledFeatures = useSelector(selectEntitledFeatures);
    const roles = useSelector((state) => state.auth.roles);
    const isSuperAdmin = useSelector((state) => state.auth.isSuperAdmin);

    return useMemo(() => {
        const hasFeature = (featureName) => {
            if (!featureName) return true;
            return entitledFeatures && entitledFeatures.includes(featureName);
        };

        const hasPermission = (requiredPermission) => {
            if (!requiredPermission) return true;
            return permissions && permissions.includes(requiredPermission);
        };

        const hasRole = (requiredRole) => {
            if (!requiredRole) return true;
            if (requiredRole === "super_admin" && isSuperAdmin) return true;
            return roles && roles.includes(requiredRole);
        };

        const canAccess = (featureName, requiredPermission) => {
            if (featureName && !hasFeature(featureName)) {
                return false;
            }

            if (requiredPermission && !hasPermission(requiredPermission)) {
                return false;
            }

            return true;
        };

        return { canAccess, hasFeature, hasPermission, hasRole };
    }, [permissions, entitledFeatures, roles, isSuperAdmin]);
}
